import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';
import logo from '../../assets/images/logo-full-alt.svg';

const Aside = Styled.aside`
display: grid;
background: ${(props) =>
  props.bg ? `url(${props.bg}) center center/cover` : color.primary};
grid-template-rows: max-content max-content;
height: 100vh;
img{width: 100%; height: 100%; object-fit: cover;};
@media only screen and (max-width: 700px){display:none};
`;

const Logo = Styled.span`
display: grid;
place-items: center;
max-width: 20rem;
text-align:center;
padding: 4rem 1rem;
`;

const List = Styled.ul`
list-style-type: disc;
color:${color.white};
max-width: 80%;

margin:auto;
`;

const Item = Styled.li`
margin: 2rem 0;
font-size: 1.8rem;
`;

const ListHeading = Styled.h4`
font-size: 2.5rem;
font-weight: ${color.white};
`;

const SectionAside = ({ items, image }) => {
  return (
    <Aside bg={image}>
      <Logo>
        <img src={logo}  alt=""/>
      </Logo>
      <List>
        <ListHeading>All services include:</ListHeading>
        {items.map((item) => (
          <Item key={item}>{item}</Item>
        ))}
      </List>
    </Aside>
  );
};

export default SectionAside;
